import { render } from "./Produtos.vue?vue&type=template&id=0792bbda&scoped=true&ts=true"
import script from "./Produtos.vue?vue&type=script&lang=ts"
export * from "./Produtos.vue?vue&type=script&lang=ts"

import "./Produtos.vue?vue&type=style&index=0&id=0792bbda&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0792bbda"]])

export default __exports__